// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  AssessmentRequest,
  GenerateOralExamPoolParams,
  GenericApiResponseOralExamConfig,
  HTTPValidationError,
  OralExamConfigUpdate,
  OralExamPoolReplaceRequest,
} from '../../models';

/**
 * Generate oral exam questions for a task and optionally persist the pool.

Returns the resulting :class:`OralExamConfig` (question pool as
``OralExamQuestion`` with resolved ids) — the same shape the replace/update
endpoints return — so the client can render the new pool directly.
 * @summary Generate Oral Exam Pool
 */
export const generateOralExamPool = (
  moduleId: string,
  version: string,
  taskId: string,
  assessmentRequest: AssessmentRequest,
  params?: GenerateOralExamPoolParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamConfig>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/oral-exam/generate-pool`,
    assessmentRequest,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGenerateOralExamPoolMutationOptions = <
  TData = Awaited<ReturnType<typeof generateOralExamPool>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: AssessmentRequest; params?: GenerateOralExamPoolParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['generateOralExamPool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOralExamPool>>,
    { moduleId: string; version: string; taskId: string; data: AssessmentRequest; params?: GenerateOralExamPoolParams }
  > = (props) => {
    const { moduleId, version, taskId, data, params } = props ?? {};

    return generateOralExamPool(moduleId, version, taskId, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: AssessmentRequest; params?: GenerateOralExamPoolParams },
    TContext
  >;
};

export type GenerateOralExamPoolMutationResult = NonNullable<Awaited<ReturnType<typeof generateOralExamPool>>>;
export type GenerateOralExamPoolMutationBody = AssessmentRequest;
export type GenerateOralExamPoolMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Generate Oral Exam Pool
 */
export const useGenerateOralExamPool = <
  TData = Awaited<ReturnType<typeof generateOralExamPool>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: AssessmentRequest; params?: GenerateOralExamPoolParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: AssessmentRequest; params?: GenerateOralExamPoolParams },
  TContext
> => {
  const mutationOptions = getGenerateOralExamPoolMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Replace the question pool with a lecturer-edited set.
 * @summary Replace Oral Exam Pool
 */
export const replaceOralExamPool = (
  moduleId: string,
  version: string,
  taskId: string,
  oralExamPoolReplaceRequest: OralExamPoolReplaceRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamConfig>> => {
  return axios.put(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/oral-exam/question-pool`,
    oralExamPoolReplaceRequest,
    options,
  );
};

export const getReplaceOralExamPoolMutationOptions = <
  TData = Awaited<ReturnType<typeof replaceOralExamPool>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamPoolReplaceRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['replaceOralExamPool'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceOralExamPool>>,
    { moduleId: string; version: string; taskId: string; data: OralExamPoolReplaceRequest }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return replaceOralExamPool(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamPoolReplaceRequest },
    TContext
  >;
};

export type ReplaceOralExamPoolMutationResult = NonNullable<Awaited<ReturnType<typeof replaceOralExamPool>>>;
export type ReplaceOralExamPoolMutationBody = OralExamPoolReplaceRequest;
export type ReplaceOralExamPoolMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Replace Oral Exam Pool
 */
export const useReplaceOralExamPool = <
  TData = Awaited<ReturnType<typeof replaceOralExamPool>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamPoolReplaceRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: OralExamPoolReplaceRequest },
  TContext
> => {
  const mutationOptions = getReplaceOralExamPoolMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update oral exam config overrides without modifying the question pool.
 * @summary Update Oral Exam Config
 */
export const updateOralExamConfig = (
  moduleId: string,
  version: string,
  taskId: string,
  oralExamConfigUpdate: OralExamConfigUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamConfig>> => {
  return axios.patch(
    `/modules/${moduleId}/versions/${version}/tasks/${taskId}/oral-exam`,
    oralExamConfigUpdate,
    options,
  );
};

export const getUpdateOralExamConfigMutationOptions = <
  TData = Awaited<ReturnType<typeof updateOralExamConfig>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamConfigUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateOralExamConfig'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOralExamConfig>>,
    { moduleId: string; version: string; taskId: string; data: OralExamConfigUpdate }
  > = (props) => {
    const { moduleId, version, taskId, data } = props ?? {};

    return updateOralExamConfig(moduleId, version, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamConfigUpdate },
    TContext
  >;
};

export type UpdateOralExamConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateOralExamConfig>>>;
export type UpdateOralExamConfigMutationBody = OralExamConfigUpdate;
export type UpdateOralExamConfigMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Oral Exam Config
 */
export const useUpdateOralExamConfig = <
  TData = Awaited<ReturnType<typeof updateOralExamConfig>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; taskId: string; data: OralExamConfigUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; taskId: string; data: OralExamConfigUpdate },
  TContext
> => {
  const mutationOptions = getUpdateOralExamConfigMutationOptions(options);

  return useMutation(mutationOptions);
};
